import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ToastrModule } from "ngx-toastr";
import { ReactiveFormsModule } from "@angular/forms";
import { APP_BASE_HREF } from "@angular/common";

import { SidebarModule } from "./sidebar/sidebar.module";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarModule } from "./shared/navbar/navbar.module";
import { FixedPluginModule } from "./shared/fixedplugin/fixedplugin.module";

import { AppComponent } from "./app.component";
import { AppRoutes } from "./app.routing";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
// import { SharedEntitiesModule } from './sharedEntities/sharedEntities.module';
import { I18nModule } from "./i18n/i18n.module";
import { NbThemeModule, NbLayoutModule, NbSidebarModule } from "@nebular/theme";
import { API_BASE_URL, RestClientService } from "./services/restclient.service";
import { AuthGuard } from "./models/auth.guard";
import { AppConsts } from "./AppConsts";
import { BlockUIModule } from "ng-block-ui";
import { CookieService } from "ngx-cookie-service";
import { LoginService } from "./services/login.service";
import { GlobalService } from "./services/global.service";
import { UserService } from "./services/user.service";
import { SessionService } from "./services/session.service";
import { AuthTokenService } from "./services/auth-token.service";
import { BlockUIService } from "./services/blockui.service";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { UsersListComponent } from "./pages/users-list/users-list.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { UsersChangePasswordComponent } from './pages/users-change-password/users-change-password.component';
import { ForgetPasswordComponent } from "./pages/forget-password/forget-password.component";
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
export function getBaseUrl(): string {
  return AppConsts.remoteServiceBaseUrl;
}

@NgModule({
  declarations: [AppComponent, AdminLayoutComponent, UsersListComponent, UsersChangePasswordComponent, ForgetPasswordComponent, ResetPasswordComponent],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
    }),
    SidebarModule,
    NavbarModule,
    FormsModule,
    NgSelectModule,
    ToastrModule.forRoot(),
    BlockUIModule.forRoot(),
    FooterModule,
    FixedPluginModule,
    ReactiveFormsModule,
    I18nModule,
    NbSidebarModule,
    NbThemeModule,
    NbLayoutModule,
    SweetAlert2Module.forRoot(),
  ],
  providers: [
    { provide: API_BASE_URL, useFactory: getBaseUrl },
    { provide: APP_BASE_HREF, useValue: "/" },
    LoginService,
    GlobalService,
    UserService,
    SessionService,
    AuthTokenService,
    BlockUIService,
    RestClientService,
    AuthGuard,
    CookieService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
